import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Card, CardBody, CardTitle, CardText, Row, Col, Table } from 'reactstrap';
import styled from 'styled-components';
import FontAwesome from 'react-fontawesome';

//images
import MandiriLogo from "../../images/logo-mandiri.png";
import BumnLogo from "../../images/logo-bumn.png";
import TravisScott from "../../images/Travis-Scott-Jordan-1-Low.png"
import BoostBlack from "../../images/Yeezy-Boost-350-V2-Triple-Black.png"
import BoostSynth from "../../images/Yeezy-Boost-350-V2-Synth.png"
import NikeDunk from "../../images/nike-dunk-low.jpg"
import NikeParra from "../../images/Parra-Nike-SB-Blazer-Low.jpg"
import AuctionFlow from "../../images/flow-auction.png"

const FiestaPointCampaign = () => {
  return(
    <div id="helps-container">

      <h1 className="text-center">E-AUCTION</h1>
      <h5 className="text-center">Fiestapoin Campaign</h5>

      <Card>
        <CardBody style={{paddingBottom: 0}}>
          <span style={{fontFamily: "Nunito Bold"}}>Dapatkan Extra Fiestapoin Campaign untuk Transaksi Kartu Mandiri di www.kickavenue.com dan Ikuti E-Auction Sneakers dengan Fiestapoin hanya di KickAvenue</span>
        </CardBody>
      </Card>
      
      <Card>
        <CardBody>
          <CardTitle>General</CardTitle>
          <CardText>
            Bank Mandiri memberikan penawaran menarik untuk mendapatkan Extra Fiestapoin atas transaksi pembelanjaan secara online menggunakan Kartu Mandiri (debit dan kredit) di www.kickavenue.com. Selanjutnya Nasabah juga dapat memperoleh sneakers melalui e-Auction menggunakan Fiestapoin yang dimiliki. Adapun detail mekanisme program tersebut adalah sebagai berikut:
          </CardText>
          <CardText>
            <Table bordered style={{marginBottom: ".5rem"}}>
              <thead>
                <tr>
                  <th>Program</th>
                  <th>Mekanisme</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Extra Fiestapoin Campaign untuk Transaksi Kartu Mandiri di www.kickavenue.com</td>
                  <td style={{padding: "0.75rem 2rem"}}>
                    <ol>
                      <li>Program berlaku mulai 01 Agustus 2019 s.d. November 2019*</li>
                      <li>Berlaku hanya bagi nasabah Bank Mandiri pemegang Mandiri Debit atau Kartu Kredit dan melakukan transaksi pembelanjaan di www.kickavenue.com.</li>
                      <li>Nasabah akan mendapatkan tambahan Fiestapoin atas transaksi pembelian dengan minimum payment melalui portal KickAvenue menggunakan Mandiri Debit atau Kartu Kredit, dengan tiering sebagai berikut:</li>
                        <ul style={{paddingLeft: "1rem"}}>
                          <li>Transaksi pembelian di KickAvenue `&gt;` IDR 1,5 Juta s.d IDR 2,99 Juta mendapatkan extra 500 Fp</li>
                          <li>Transaksi pembelian di KickAvenue `&gt;` IDR 3 Juta s.d IDR 3,99 Juta mendapatkan extra 1.000 Fp</li>
                          <li>Transaksi pembelian di KickAvenue `&gt;` IDR 5 Juta mendapatkan extra 2.000 Fp</li>
                        </ul>
                      <li>Penambahan fiestapoin tidak terjadi secara realtime, berlaku SLA minimal 14 hari kerja setelah tanggal transaksi di www.kickavenue.com</li>
                      <li>Promo ini berlaku untuk setiap kali nasabah melakukan transaksi pembelian di www.kickavenue.com selama periode berlangsung.</li>
                      <li>Nasabah dapat memperoleh double benefit dari program pengumpulan kupon Raffle dan Extra Fiestapoin selama sesuai dengan ketentuan yang berlaku pada masing-masing program.</li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td>E-Auction Sneakers dengan Fiestapoin di @KickAvenue</td>
                  <td style={{padding: "0.75rem 2rem"}}>
                    <ol>
                      <li>Program e-Auction akan dilaksanakan pada September 2019 di Instagram @kickavenue.</li>
                      <li>Program ini berlaku hanya bagi nasabah Bank Mandiri pemegang Mandiri Debit atau Kartu Kredit yang memiliki Fiestapoin atau telah mendapatkan extra Fiestapoin pembelanjaan di www.kickavenue.com</li>
                      <li>Peserta e-Auction mendaftarkan User Instagram, User di Kickavenue (email) dan No. Handphone aktif yang terdaftar di Portal Fiestapoin (web/app), pada periode sebelum e-Auction yaitu maksimal H-2 sebelum e-auction dilaksanakan.</li>
                      <li>Bagi peserta e-Auction yang ikut melakukan bidding namun belum melakukan pendaftaran User IG, User KickAvenue (email) dan No handphone aktif di portal Fiestapoin, maka peserta tersebut dianggap gugur.</li>
                      <li>Minimal bidding dimulai dari 1.000 Fiestapoin dengan kelipatan 500 Fiestapoin.</li>
                      <li>Hadiah e-Auction per minggu ±1 (satu) pasang sneakers dengan total 5 pairs of sneakers selama program*.</li>
                      <li>Periode e-Auction beserta kuota hadiah adalah sbb*:</li>
                        <ul style={{paddingLeft: "1rem"}}>
                          <li>13 September <FontAwesome name="arrow-right"/> E-Auction 1 (satu) pasang sneakers senilai IDR. 14 – 19 Juta</li>
                          <li>20 September <FontAwesome name="arrow-right"/> E-Auction 2 (dua) pasang sneakers senilai IDR. 14 – 19 Juta</li>
                          <li>20 September <FontAwesome name="arrow-right"/> E-Auction 2 (dua) pasang sneakers senilai IDR. 14 – 19 Juta</li>
                        </ul>
                    </ol>
                  </td>
                </tr>
              </tbody>
            </Table>
            <span style={{fontSize: ".5rem"}}>*)Ket: Periode program, pelaksanaan program, kuota dan jenis hadiah dapat berubah sewaktu-waktu sesuai kebijakan Bank Mandiri</span>
          </CardText>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Periode dan Pelaksanaan Program</CardTitle>
          <CardText style={{paddingLeft: "1rem"}}>
            <ol>
              <li>Extra Fiestapoin Campaign untuk Transaksi Kartu Mandiri di www.kickavenue.com berlaku mulai 01 Agustus 2019 hingga akhir November 2019</li>
              <li>E-Auction Sneakers dengan Fiestapoin di @KickAvenue berlaku pada:</li>
                <ul style={{paddingLeft: "1rem"}}>
                  <li>13 September <FontAwesome name="arrow-right"/> E-Auction 1 (satu) pasang sneakers senilai IDR. 14 – 19 Juta</li>
                  <li>20 September <FontAwesome name="arrow-right"/> E-Auction 2 (dua) pasang sneakers senilai IDR. 14 – 19 Juta</li>
                  <li>27 September <FontAwesome name="arrow-right"/> E-Auction 2 (dua) pasang sneakers senilai IDR. 14 – 19 Juta</li>
                </ul>
            </ol>
          </CardText>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Syarat dan Ketentuan</CardTitle>
          <CardText style={{paddingLeft: "1rem"}}>
            <ol>
              <li>Extra Fiestapoin Campaign untuk Transaksi Kartu Mandiri di www.kickavenue.com :</li>
                <ul style={{paddingLeft: "1rem"}}>
                  <li>
                    Berlaku hanya bagi nasabah Bank Mandiri pemegang Mandiri Debit atau Kartu Kredit dan pembelanjaan di www.kickavenue.com
                  </li>
                  <li>
                    Nasabah akan mendapatkan tambahan Fiestapoin khusus pembelian dengan minimal transaksi yang ditentukan melalui portal KickAvenue dengan Mandiri Debit atau Kartu Kredit dengan tiering sebagai berikut:
                  </li>
                    <ol style={{paddingLeft: "1rem"}}>
                      <li>Transaksi pembelian di KickAvenue `&gt;` IDR 1,5 Juta s.d IDR 2,99 Juta mendapatkan extra 500 Fp</li>
                      <li>Transaksi pembelian di KickAvenue `&gt;` IDR 3 Juta s.d IDR 3,99 Juta mendapatkan extra 1.000 Fp</li>
                      <li>Transaksi pembelian di KickAvenue `&gt;` IDR 5 Juta mendapatkan extra 2.000 Fp</li>
                    </ol>
                  <li>
                    Extra fiestapoin akan dikreditkan ke nasabah maksimal ± 14 Hari Kerja setelah tanggal transaksi pembelanjaan di www.kickavenue.com
                  </li>
                  <li>
                    Extra fiestapoin dapat digunakan untuk e-Auction Sneakers yang akan berlangsung di bulan September ataupun promo Thank Goodness It’s Fiestapoin (TGIF) maupun redemption di katalog maupun merchants yang bekerjasama.
                  </li>
                  <li>
                    Nasabah dapat memperoleh benefit double dari program pengumpulan kupon Raffle dan Extra Fiestapoin selama sesuai dengan ketentuan yang berlaku pada masing-masing program
                  </li>
                  <li>
                    Transaksi hanya dengan menggunakan Mandiri Kartu Debit/Kredit Visa Classic, Visa Gold, Golf Gold, Everyday, SKYZ, World Elite, Signature, Golf Signature, Platinum, Fengshui, Pertamina, Golf Platinum, Visa Silver, Visa Gold, Visa Platinum, Visa Platinum Private, Visa Platinum Prioritas, Visa Silver Culture, Visa Gold Culture, Visa Platinum Culture, Visa Platinum Co-Brand Garuda, dan Visa Gold Co-Brand Asian Game.
                  </li>
                </ul>
                <li>E-Auction Sneakers dengan Fiestapoin di @KickAvenue:</li>
                  <ul style={{paddingLeft: "1rem"}}>
                    <li>
                      Berlaku hanya bagi nasabah Bank Mandiri pemegang Mandiri Debit atau Kartu Kredit dan pembelanjaan di www.kickavenue.com
                    </li>
                    <li>
                      Hanya peserta yang telah mendaftarkan data diri di portal Fiestapoin yang eligible mengikuti e-auction
                    </li>
                    <li>Pendaftaran data diri peserta e-auction maksimal H-2 sebelum e-auction dilaksanakan</li>
                    <li>E-auction hanya dilakukan pada portal kickavenue</li>
                    <li>Minimal bidding adalah 1.000 Fiestapoin dengan kelipatan 500 Fiestapoin</li>
                    <li>Fiestapoin yang sudah ditukarkan tidak dapat dikembalikan/dibatalkan</li>
                    <li>Hadiah akan hangus jika 2x24 jam pemenang tidak dapat dihubungi</li>
                    <li>Jika pemenang e-auction tidak memiliki cukup fiestapoin, maka pemenang akan diganti sesuai kebijakan Bank Mandiri</li>
                    <li>Bank Mandiri berhak melakukan verifikasi sesuai dengan syarat dan ketentuan promo, dan keputusan Bank tidak dapat diganggu gugat</li>
                    <li>Kuota, jenis hadiah, size sneakers dan pelaksanaan program dapat berubah-ubah sewaktu-waktu sesuai dengan kebijakan Bank Mandiri</li>
                  </ul>
            </ol>
          </CardText>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Pengumuman Pemenang e-Auction Sneakers dengan Fiestapoin</CardTitle>
          <ol style={{paddingLeft: "1rem"}}>
            <li>Pemenang akan dihubungi oleh pihak KickAvenue</li>
            <li>Pemenang e-Auction dapat memilih size sneakers selama persediaan masih ada</li>
            <li>Setiap pemenang akan diumumkan secara resmi pada setiap periode e-Auction melalui Instagram Kick Avenue dan Microsite Fiestapoin Bank Mandiri</li>
          </ol>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Jenis Sneakers</CardTitle>
          <CardText>
            <Table bordered>
              <thead>
                <tr>
                  <td>No.</td>
                  <td>Jenis Sneakers</td>
                  <td>Jumlah</td>
                  <td style={{width: "30%"}}>Gambar</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Travis Scott Jordan 1 Low</td>
                  <td>1</td>
                  <td>
                    <WrapperSneakers>
                      <KickImage src={TravisScott} alt="Travis-Scott-Jordan-1-Low.png"/>
                    </WrapperSneakers>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Adidas Yeezy Boost 350 V2 Black & Synth</td>
                  <td>2</td>
                  <td>
                    <WrapperSneakers>
                      <KickImage src={BoostBlack} alt="Yeezy-Boost-350-V2-Triple-Black.png"/>
                      <KickImage src={BoostSynth} alt="Yeezy-Boost-350-V2-Synth.png"/>
                    </WrapperSneakers>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Parra x Nike Blazer dan SB Dunk Low</td>
                  <td>2</td>
                  <td>
                    <WrapperSneakers>
                      <KickImage src={NikeParra} alt="Parra-Nike-SB-Blazer-Low.jpg"/>
                      <KickImage src={NikeDunk} alt="nike-dunk-low.jpg"/>
                    </WrapperSneakers>
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardText>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Pengiriman Sneakers</CardTitle>
            <ol style={{paddingLeft: "1rem"}}>
              <li>Nasabah wajib memberikan alamat lengkap untuk pengiriman dan memilih size sneakers sesuai ketersediaan</li>
              <li>Pengiriman sneaker ±21 Hari Kerja</li>
              <li>Sneakers yang telah dikirimkan tidak dapat ditukarkan dengan size berbeda</li>
              <li>Jika terdapat kesalahan alamat pengiriman sepenuhnya menjadi tanggung jawab pemenang, dan sneakers akan sepenuhnya menjadi milik Bank Mandiri</li>
            </ol>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <CardTitle>Alur Program E-Auction</CardTitle>
            <WrapperImg>
              <KickImage src={AuctionFlow} alt="auction-flow"/>
            </WrapperImg>
        </CardBody>
      </Card>
    
      <WrapperLogo>
        <div className="wrapper-child">
          <KickImage src={MandiriLogo} alt="logo-mandiri"/>
          <KickImage src={BumnLogo} alt="logo-bumn"/>
        </div>
      </WrapperLogo>

    </div>
  )
}

const WrapperLogo = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 2px solid #ccc;
  padding-top: 3rem;
  .wrapper-child{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 2rem;
    img{
      object-fit: contain;
      width: 196px;
      height: 54px;
      ${'' /* &:first-child{
        width: 196px;
        height: 54px;
      }
      &:nth-child(2){
        width: 100%;
      } */}
    }
  }
  @media (min-width: 320px) and (max-width: 480px){
    padding-top: 1rem;
    .wrapper-child{
      margin-bottom: 1rem;
      img{
        object-fit: contain;
        &:first-child{
          width: 90px;
        }
        &:nth-child(2){
          width: 60px;
        }
      }
    }
  }
`

const WrapperImg = styled.div`
display: flex;
justify-content: center;
margin-top: 2rem;
  img{
    width: 70%
  }
  @media (min-width: 320px) and (max-width: 480px){
    img{
      width: 100%
    }
  }
`

const WrapperSneakers = styled.div`
  img{
    width: 50%
  }
`

export default FiestaPointCampaign;